<template>
  <div class="wrapperx">
    <div class="full-area padded vertically-centered desktop-wrapper logo-wrapper">
      <SensataSplash></SensataSplash>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Rsvp',

  transition: 'page',

  props: [ 'bgImage' ],

  components: {
    SensataSplash: () => import('Components/base/SensataSplash')
  },

  mounted () {
    var sensataSplashTimer = process.env.VUE_APP_SHOW_SENSATA_SPLASH ? 2200 : 0

    setTimeout(() => {
      window.location = 'https://lareinvencindelainvestigacindelcliente.splashthat.com/'
    }, sensataSplashTimer)
  }
}
</script>

<style scoped lang="scss">
.logo-wrapper {
  max-width: 80vw !important;
  @include breakpoint($tablet) {
    max-width: 40vw !important;
  }
  @include breakpoint($desktop) {
    max-width: 360px !important;
  }
}

</style>
<style scoped lang="scss">
h1 {
  color: $color-emphasis;
}

.wrapper {
  background: white !important;
}
.desktop-wrapper {
  box-shadow: none;
}
</style>
